import React, { useState } from 'react';
import { Screen } from '../types';
import arunachalLogo from '../../../assets/Arunachal-Pradesh.png';
import aadhaarLogo from '../../../assets/aadhaar-logo.png';

const ConsentScreen = ({ navigateTo }) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="ilp-screen">
      <div className="ilp-header">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.Home)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Identity Verification</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-consent-content">
        <div className="ilp-consent-logos">
          <div className="ilp-consent-logo">
            <img src={arunachalLogo} alt="Arunachal Pradesh" />
          </div>
          <div className="ilp-consent-divider"></div>
          <div className="ilp-consent-logo aadhaar">
            <img src={aadhaarLogo} alt="Aadhaar" />
          </div>
        </div>

        <div className="ilp-consent-text">
          <h1>Consent for Aadhaar Verification</h1>
          <p>To issue your Inner Line Permit (ILP), the Government of Arunachal Pradesh requires verification of your identity using Aadhaar e-KYC or physical card verification.</p>
          <p className="ilp-small">Your data is handled according to IT Act 2000. We only retrieve verified demographic details for permit generation.</p>
        </div>

        <div className="ilp-secure-badge">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clipRule="evenodd" />
          </svg>
          <span>End-to-End Secured</span>
        </div>
      </div>

      <div className="ilp-consent-footer">
        <label className="ilp-checkbox-label">
          <input 
            type="checkbox" 
            checked={agreed} 
            onChange={() => setAgreed(!agreed)}
          />
          <div className={`ilp-checkbox ${agreed ? 'checked' : ''}`}>
            {agreed && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <path d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>I hereby give my consent to use my Aadhaar number or physical card for verification purposes.</span>
        </label>

        <button 
          className={`ilp-primary-btn full ${!agreed ? 'disabled' : ''}`}
          disabled={!agreed}
          onClick={() => navigateTo(Screen.VerificationMethod)}
        >
          <span>Continue to Verification</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ConsentScreen;

